<template>
    <div class="flex gap-1">
        <transaction-link
            v-if="!transactionView"
            :transaction-uuid="transaction.uuid"
            title="Gå til bilag"
            :data-cy="`inspect-transaction-${transaction.uuid}`"
            class="text-lg i-mdi-file-search-outline hover:text-primary"
        />
        <copy-icon-button
            v-if="!transaction.deleted && !transactionView"
            tooltip="Kopier bilag"
            :data-cy="`copy-transaction-${transaction.uuid}`"
            :on-click="() => openCopyTransaction(transaction)"
        />
        <edit-icon-button
            v-if="!transaction.deleted && !outgoingInvoice"
            tooltip="Endre bilag"
            :data-cy="`update-transaction-${transaction.uuid}`"
            :on-click="() => openEditTransaction(transaction)"
            icon="i-ph:pencil"
        />
        <targeting-router-link
            v-else-if="outgoingInvoice"
            title="Endre faktura"
            class="text-lg i-ph:pencil hover:text-primary self-center"
            :data-cy="`invoice-link-${transaction.uuid}`"
            :to="invoiceLinkTarget"
        >
            <slot/>
        </targeting-router-link>
        <confirmable-delete-icon-button
            v-if="!transaction.deleted && !outgoingInvoice"
            tooltip="Slett bilag"
            :data-cy="`delete-transaction-${transaction.uuid}`"
            :on-click-delete="() => onClickDelete()"
            :align-confirm="'left'"
        />
    </div>
</template>

<script setup lang="ts">

import {Transaction} from '@/types/transaction/Transaction'
import TransactionLink from '@/transaction/TransactionLink.vue'
import {computed} from 'vue'
import {useEditTransactionCreator} from '@/transaction/edit-transaction/EditTransaction.service'
import {TransactionLine} from '@/types/transaction/TransactionLine'
import {INVOICE_VIEW} from '@/invoice'
import { TargetingRouterLink } from '@tritt/multipanel'

const {openEditTransaction, openCopyTransaction} = useEditTransactionCreator()

const props = defineProps({
    transaction: {
        type: Object as () => Transaction,
        required: true
    },
    transactionView: Boolean,
    onClickDelete: {
        type: Function,
        required: true
    }
})

const outgoingInvoice = computed<boolean>(() => {
    const lines = props.transaction?.transactionLines ?? []
    return lines.some((line: TransactionLine) => {
        return !!line.invoiceUuid && line.accountNo.startsWith('3')
    })
})

const invoiceUuid = computed(() => props.transaction?.transactionLines
    .find((line: TransactionLine) => !!line.invoiceUuid)
    ?.invoiceUuid)

const invoiceLinkTarget = computed(() => {
    return {
        componentName: INVOICE_VIEW.componentName,
        queryValues: {invoiceUuid: invoiceUuid.value || ''},
    }
})

</script>

<style scoped>

</style>